import { Button, Drawer, Input } from "@components";
import { useEffect, useState } from "react";

import styles from "@styles/containers/cdp/add-coupon.module.scss";
import InternalBenefitAPI from "providers/InternalBenefitAPI";

export function AddCoupon({ visible, onClose, onAdd, customer }) {
  const [code, setCode] = useState("");
  const [pin, setPin] = useState("");

  const [loading, setLoading] = useState(false);
  
  const isValid = code && pin && pin.length >= 3;

  const addCoupon = async () => {
    setLoading(true);

    const internalBenefitAPI = new InternalBenefitAPI();

    const response = await internalBenefitAPI.addStandaloneCoupon({
      code, 
      pin,
      customerId: customer.id
    });

    const errors = response.getErrors([]);
    if (errors.length > 0) {
      setLoading(false);
      return alert({ text: errors[0], buttonText: "Ok" });
    }

    onAdd();

    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      setCode("");
      setPin("");
    }
  }, [visible]);
  
  return (
    <Drawer
      visible={visible}

      onClose={() => onClose && onClose()}
      title="Adicionar benefício"
      showBackButton
      withoutTransition
      backAction={() => onClose && onClose()}
    >
      <div className={styles.addCoupon}>
        <p className={styles.title}>
          Insira o código e o pin do cupom que você deseja adicionar a sua lista
          de benefícios.
        </p>
        <div className={styles.codeAndPin}>
          <div className="d-flex flex-column w-100">
            <label>Cód. Cupom</label>
            <Input
              design="two"
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className="d-flex flex-column w-100">
            <label>PIN</label>
            <Input
              design="two"
              onChange={(e) => setPin(e.target.value)}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => addCoupon()}
            disabled={!isValid || loading}
            loading={loading}
          >
            Adicionar benefício
          </Button>
        </div>
      </div>
    </Drawer>
  );
}
